// extracted by mini-css-extract-plugin
export var chip = "_5n-0";
export var filterDropdown = "_5n-5";
export var filterItem = "_5n-6";
export var icon = "_5n-1";
export var removeButton = "_5n-3";
export var removeIcon = "_5n-4";
export var separator = "_5n-2";